import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getCampaignElementById,
  getCampaignElementTypes,
  getCampaignAutoTags
} from '@src/redux/modules/campaignLandingPage';
import CampaignQuestionContainer from '@src/components/CampaignLanding/CampaignQuestionContainer';
import TextInput from '@src/components/CampaignLanding/TextInput';
import TextAreaInput from '@src/components/CampaignLanding/TextAreaInput';
import RichText from '@src/components/CampaignLanding/RichText';
import ImageElement from '@src/components/CampaignLanding/ImageElement';
import VideoElement from '@src/components/CampaignLanding/VideoElement';
import CheckboxElement from '@src/components/CampaignLanding/CheckboxElement';
import FileUploadInput from '@src/components/CampaignLanding/FileUploadInput';
import SignatureElement from '@src/components/CampaignLanding/SignatureElement';
import SubmissionTypeSelectorField from '@src/components/CampaignLanding/SubmissionTypeSelectorField';

import CampaignRatingInput from '@vp-ui/components/CampaignRatingInput/CampaignRatingInput';
import MultipleChoice from '@vp-ui/components/MultipleChoice/MultipleChoice';
import crakIds from '@src/constants/crak';

const ElementFacade = (props) => {
  switch (props.elementTypesMap[props.element.elementTypeId]) {
    case 'Video Response': {
      return <CampaignQuestionContainer {...props} />;
    }

    case 'File Attachment': {
      return <FileUploadInput {...props} />;
    }

    case 'Short Answer': {
      return <TextInput {...props} />;
    }

    case 'Written Response': {
      return <TextAreaInput {...props} />;
    }

    case 'Rich Text': {
      return <RichText {...props} />;
    }

    case 'Image': {
      return <ImageElement {...props} />;
    }

    case 'Video Message': {
      return <VideoElement {...props} />;
    }

    case 'Signature': {
      return <SignatureElement {...props} />;
    }

    case 'Checkbox': {
      return <CheckboxElement {...props} />;
    }

    case 'Rating': {
      return <CampaignRatingInput {...props} />;
    }

    case 'Multiple Choice': {
      const isAutotagElement = props.element?.crakId === crakIds.AUTOTAG_INPUT;
      if (isAutotagElement && props.autotags?.length > 0) {
        return null;
      }

      return <MultipleChoice {...props} />;
    }

    case 'Submission Type Selector': {
      return <SubmissionTypeSelectorField {...props} />;
    }

    default:
      return null;
  }
};

ElementFacade.propTypes = {
  elementTypesMap: PropTypes.object,
  element: PropTypes.object,
  autotags: PropTypes.array
};

function mapStateToProps(state, ownProps) {
  return {
    elementTypesMap: getCampaignElementTypes(state),
    element: getCampaignElementById(state, ownProps.qid),
    autotags: getCampaignAutoTags(state)
  };
}

export default connect(mapStateToProps)(ElementFacade);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/ElementFacade.jsx